import {get, last} from 'lodash'
import {getDefaultEntityId} from 'selectors/contacts'

export const getSelectedCompanyId = state => get(state, 'quotingContext.selected.companyId')
export const getSelectedContactId = state => state.quotingContext.selected.contactId
export const getSelectedOrder = state => state.quotingContext.selected.order
export const getSelectedOrderId = state => get(state.quotingContext.selected.order, 'id')
export const getSelectedOrderItems = state => state.quotingContext.selected.items.data.data
export const getSelectedCurrentTab = state => state.quotingContext.selected.currentTab || 'quote'
export const getLastOrder = state => last(state.quotingContext.selected.changeLogQuote)
export const getLastOrderItems = state => last(state.quotingContext.selected.changeLogQuoteItems)
export const getDeletedItems = state => state.quotingContext.selected.deletedItems
export const getRevisions = state => state.quotingContext.selected.revisions.data || []
export const getOrderSummaryInfo = state => state.quotingContext.selected.summaryInfo || {}
export const getCurrentDetailsTab = state => state.quotingContext.selected.currentDetailsTab
export const getSubItems = state => state.quotingContext.selected.itemDrawer.subItems.data.data
export const getSearchField = state => state.quotingContext.selected.delivery.search || ''

export const getSelectedOrderItem = (state, orderItemId) => {
  return getSelectedOrderItems(state).find(item => item.id === orderItemId)
}

export const getDefaultQuoteId = state => {
  const contactId = getSelectedContactId(state)
  const companyId = getSelectedCompanyId(state)
  return getDefaultQuoteIdForCompanyOrContact(state, contactId, companyId)
}

export const getDefaultQuoteIdForCompanyOrContact = (state, contactId, companyId) => {
  return getDefaultEntityId(
    state,
    contactId,
    companyId,
    'recentContactQuotes',
    'recentCompanyQuotes',
    'latestOrder'
  )
}

export const getShowAllPurchaseOrderRevisions = state =>
  get(state, 'quotingContext.selected.purchasingTab.showAllRevisions', false)

export const getSelectedQuoteDocumentSubFolder = state => state.quotingContext.selected.documents.subFolder
export const getSelectedQuoteDocumentsCurrentFolder = state => state.quotingContext.selected.documents.currentFolder
export const getSelectedQuoteDocuments = state => state.quotingContext.selected.documents.pivotTable.data.data
export const getNewSelectedQuoteDocuments = state => state.quotingContext.selected.newDocuments.pivotTable.data.data

export const getSelectedQuoteApprovalDrawer = state => state.quotingContext.selected.approvals.approvalDrawer
export const getSelectedQuoteApprovalRevisionsDrawer = state =>
  state.quotingContext.selected.approvals.approvalDrawer.revisionsDrawer

export const getApprovalCustomerLink = state => state.quotingContext.selected.approvals.customerLink
export const getApprovalsCount = state => state.quotingContext.selected.approvals.pivotTable.data.count
export const getApprovals = state =>  state.quotingContext.selected.approvals.pivotTable.data.data

export const getQuotingSelector = state => state.quotingContext.selector
export const getApprovalsFilters = state => state.quotingContext.approvals.filters

export const getBulkCloseQuotesCount = state => {
  return get(state, 'quotingContext.bulkCloseQuotesDialog.count', 0)
}
export const getBulkCloseQuotesOrderIds = state => {
  return get(state, 'quotingContext.bulkCloseQuotesDialog.orderIds', [])
}
export const isBulkCloseOrRejectOrdersDialogVisible = state => {
  return get(state, 'quotingContext.bulkCloseQuotesDialog.isVisible', false)
}
export const isBulkCloseOrRejectOrdersDialogBusy = state => {
  return get(state, 'quotingContext.bulkCloseQuotesDialog.isBusy', false)
}

export const getPricingCalculatorDrawer = state => {
  return get(state, 'quotingContext.selected.pricingCalculatorDrawer')
}
